import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onAddToCart, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {[...Array(6)]?.map((_, index) => (
          <div
            key={index}
            className="rounded-xl overflow-hidden animate-pulse"
            style={{
              background: 'var(--color-card)',
              border: '1px solid var(--color-border)'
            }}
          >
            <div className="w-full h-60 md:h-64"
              style={{ background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%)' }} />
            <div className="p-4 md:p-6 space-y-3 md:space-y-4">
              <div className="h-4 md:h-5 rounded" style={{ background: 'var(--color-muted)', width: '60%' }} />
              <div className="h-5 md:h-6 rounded" style={{ background: 'var(--color-muted)', width: '90%' }} />
              <div className="h-4 md:h-5 rounded" style={{ background: 'var(--color-muted)', width: '40%' }} />
              <div className="flex justify-between items-center pt-3 md:pt-4">
                <div className="h-6 md:h-8 rounded" style={{ background: 'var(--color-muted)', width: '30%' }} />
                <div className="h-8 md:h-10 rounded" style={{ background: 'var(--color-muted)', width: '35%' }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (products?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
        <div className="w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-full flex items-center justify-center mb-4 md:mb-6"
          style={{
            background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%)',
            border: '2px solid var(--color-border)'
          }}>
          <svg className="w-10 h-10 md:w-12 md:h-12 lg:w-16 lg:h-16" fill="none" viewBox="0 0 24 24" stroke="var(--color-muted-foreground)">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
        </div>
        <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-2 md:mb-3 text-center">No Products Found</h3>
        <p className="text-sm md:text-base text-muted-foreground text-center max-w-md">
          We couldn't find any products matching your filters. Try adjusting your search criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {products?.map((product) => (
        <ProductCard
          key={product?.id}
          product={product}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
};

export default ProductGrid;